var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortArrowUp = function SvgSortArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "9px",
    viewBox: "0 0 10 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.200000, -0.200000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.93361111 0.202222222 9.75583333 8.6025 0.155833333 8.6025"
  }))));
};
export default SvgSortArrowUp;